export default {
  title_one: 'Utilização única, {{discount}}',
  title_other: '{{count}} utilizações, {{discount}}',
  labels: {
    fixed_discount: 'Desconto total de {{discount}}',
    percentage_discount: 'Desconto percentual',
  },
  buttons: {
    add_component: 'Adicionar utilização',
  },
};
